var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name != 'UnitDetails')?_c('div',{staticClass:"footer",style:({height : _vm.$store.state.beData.FooterHeight + _vm.$store.state.beData.FooterHeightStyle })},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.footerPreview)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c31881a","hasScoped":false,"buble":{"transforms":{}}}!./src/components/homeModule/footerComponent/footerComponent.template.html
// module id = 302
// module chunks = 0